var map = {
	"./prism-abap": "zdQ5",
	"./prism-abap.js": "zdQ5",
	"./prism-abap.min": "vnuT",
	"./prism-abap.min.js": "vnuT",
	"./prism-actionscript": "s5ap",
	"./prism-actionscript.js": "s5ap",
	"./prism-actionscript.min": "H+bb",
	"./prism-actionscript.min.js": "H+bb",
	"./prism-ada": "aaSS",
	"./prism-ada.js": "aaSS",
	"./prism-ada.min": "oyMD",
	"./prism-ada.min.js": "oyMD",
	"./prism-apacheconf": "i6nu",
	"./prism-apacheconf.js": "i6nu",
	"./prism-apacheconf.min": "eLV1",
	"./prism-apacheconf.min.js": "eLV1",
	"./prism-apl": "yX3g",
	"./prism-apl.js": "yX3g",
	"./prism-apl.min": "3IyS",
	"./prism-apl.min.js": "3IyS",
	"./prism-applescript": "ZDHS",
	"./prism-applescript.js": "ZDHS",
	"./prism-applescript.min": "LiGB",
	"./prism-applescript.min.js": "LiGB",
	"./prism-arduino": "t9tV",
	"./prism-arduino.js": "t9tV",
	"./prism-arduino.min": "wMcO",
	"./prism-arduino.min.js": "wMcO",
	"./prism-arff": "/DdP",
	"./prism-arff.js": "/DdP",
	"./prism-arff.min": "ET6s",
	"./prism-arff.min.js": "ET6s",
	"./prism-asciidoc": "UIyl",
	"./prism-asciidoc.js": "UIyl",
	"./prism-asciidoc.min": "0luJ",
	"./prism-asciidoc.min.js": "0luJ",
	"./prism-asm6502": "69yL",
	"./prism-asm6502.js": "69yL",
	"./prism-asm6502.min": "PoI2",
	"./prism-asm6502.min.js": "PoI2",
	"./prism-aspnet": "d7Bd",
	"./prism-aspnet.js": "d7Bd",
	"./prism-aspnet.min": "W+1Q",
	"./prism-aspnet.min.js": "W+1Q",
	"./prism-autohotkey": "FU8I",
	"./prism-autohotkey.js": "FU8I",
	"./prism-autohotkey.min": "6FId",
	"./prism-autohotkey.min.js": "6FId",
	"./prism-autoit": "moj9",
	"./prism-autoit.js": "moj9",
	"./prism-autoit.min": "AFV9",
	"./prism-autoit.min.js": "AFV9",
	"./prism-bash": "+uAN",
	"./prism-bash.js": "+uAN",
	"./prism-bash.min": "xYSV",
	"./prism-bash.min.js": "xYSV",
	"./prism-basic": "0p3n",
	"./prism-basic.js": "0p3n",
	"./prism-basic.min": "iOFK",
	"./prism-basic.min.js": "iOFK",
	"./prism-batch": "RJBC",
	"./prism-batch.js": "RJBC",
	"./prism-batch.min": "NbYe",
	"./prism-batch.min.js": "NbYe",
	"./prism-bison": "WQQL",
	"./prism-bison.js": "WQQL",
	"./prism-bison.min": "++mI",
	"./prism-bison.min.js": "++mI",
	"./prism-brainfuck": "txtB",
	"./prism-brainfuck.js": "txtB",
	"./prism-brainfuck.min": "WPrX",
	"./prism-brainfuck.min.js": "WPrX",
	"./prism-bro": "YdIE",
	"./prism-bro.js": "YdIE",
	"./prism-bro.min": "IN0N",
	"./prism-bro.min.js": "IN0N",
	"./prism-c": "nLW9",
	"./prism-c.js": "nLW9",
	"./prism-c.min": "bOLe",
	"./prism-c.min.js": "bOLe",
	"./prism-clike": "cP7M",
	"./prism-clike.js": "cP7M",
	"./prism-clike.min": "0p1x",
	"./prism-clike.min.js": "0p1x",
	"./prism-clojure": "CoI9",
	"./prism-clojure.js": "CoI9",
	"./prism-clojure.min": "oEXH",
	"./prism-clojure.min.js": "oEXH",
	"./prism-coffeescript": "EzDK",
	"./prism-coffeescript.js": "EzDK",
	"./prism-coffeescript.min": "zisN",
	"./prism-coffeescript.min.js": "zisN",
	"./prism-core": "BKAN",
	"./prism-core.js": "BKAN",
	"./prism-core.min": "U1fd",
	"./prism-core.min.js": "U1fd",
	"./prism-cpp": "zUCJ",
	"./prism-cpp.js": "zUCJ",
	"./prism-cpp.min": "XlUn",
	"./prism-cpp.min.js": "XlUn",
	"./prism-crystal": "/LQc",
	"./prism-crystal.js": "/LQc",
	"./prism-crystal.min": "Jz5Z",
	"./prism-crystal.min.js": "Jz5Z",
	"./prism-csharp": "aIOA",
	"./prism-csharp.js": "aIOA",
	"./prism-csharp.min": "f3VV",
	"./prism-csharp.min.js": "f3VV",
	"./prism-csp": "nrEO",
	"./prism-csp.js": "nrEO",
	"./prism-csp.min": "tlGB",
	"./prism-csp.min.js": "tlGB",
	"./prism-css": "4k0j",
	"./prism-css-extras": "4Sac",
	"./prism-css-extras.js": "4Sac",
	"./prism-css-extras.min": "W/VL",
	"./prism-css-extras.min.js": "W/VL",
	"./prism-css.js": "4k0j",
	"./prism-css.min": "Kjlv",
	"./prism-css.min.js": "Kjlv",
	"./prism-d": "2QFR",
	"./prism-d.js": "2QFR",
	"./prism-d.min": "lu9t",
	"./prism-d.min.js": "lu9t",
	"./prism-dart": "s5mZ",
	"./prism-dart.js": "s5mZ",
	"./prism-dart.min": "5KWD",
	"./prism-dart.min.js": "5KWD",
	"./prism-diff": "+Q++",
	"./prism-diff.js": "+Q++",
	"./prism-diff.min": "7jaG",
	"./prism-diff.min.js": "7jaG",
	"./prism-django": "zHUa",
	"./prism-django.js": "zHUa",
	"./prism-django.min": "CC4D",
	"./prism-django.min.js": "CC4D",
	"./prism-docker": "hNZJ",
	"./prism-docker.js": "hNZJ",
	"./prism-docker.min": "wPcL",
	"./prism-docker.min.js": "wPcL",
	"./prism-eiffel": "+vqG",
	"./prism-eiffel.js": "+vqG",
	"./prism-eiffel.min": "P6pa",
	"./prism-eiffel.min.js": "P6pa",
	"./prism-elixir": "LD++",
	"./prism-elixir.js": "LD++",
	"./prism-elixir.min": "LtCu",
	"./prism-elixir.min.js": "LtCu",
	"./prism-elm": "MhF6",
	"./prism-elm.js": "MhF6",
	"./prism-elm.min": "vuoU",
	"./prism-elm.min.js": "vuoU",
	"./prism-erb": "a5BK",
	"./prism-erb.js": "a5BK",
	"./prism-erb.min": "5JNR",
	"./prism-erb.min.js": "5JNR",
	"./prism-erlang": "A3U1",
	"./prism-erlang.js": "A3U1",
	"./prism-erlang.min": "A52E",
	"./prism-erlang.min.js": "A52E",
	"./prism-flow": "IcsU",
	"./prism-flow.js": "IcsU",
	"./prism-flow.min": "YNmC",
	"./prism-flow.min.js": "YNmC",
	"./prism-fortran": "bAaB",
	"./prism-fortran.js": "bAaB",
	"./prism-fortran.min": "3aHD",
	"./prism-fortran.min.js": "3aHD",
	"./prism-fsharp": "wg74",
	"./prism-fsharp.js": "wg74",
	"./prism-fsharp.min": "vmZ6",
	"./prism-fsharp.min.js": "vmZ6",
	"./prism-gedcom": "9vDN",
	"./prism-gedcom.js": "9vDN",
	"./prism-gedcom.min": "GeO+",
	"./prism-gedcom.min.js": "GeO+",
	"./prism-gherkin": "+F9R",
	"./prism-gherkin.js": "+F9R",
	"./prism-gherkin.min": "Xdsr",
	"./prism-gherkin.min.js": "Xdsr",
	"./prism-git": "W8YF",
	"./prism-git.js": "W8YF",
	"./prism-git.min": "hrGJ",
	"./prism-git.min.js": "hrGJ",
	"./prism-glsl": "tynt",
	"./prism-glsl.js": "tynt",
	"./prism-glsl.min": "wrgu",
	"./prism-glsl.min.js": "wrgu",
	"./prism-go": "wgWe",
	"./prism-go.js": "wgWe",
	"./prism-go.min": "gReS",
	"./prism-go.min.js": "gReS",
	"./prism-graphql": "oryP",
	"./prism-graphql.js": "oryP",
	"./prism-graphql.min": "ShRQ",
	"./prism-graphql.min.js": "ShRQ",
	"./prism-groovy": "4Dgg",
	"./prism-groovy.js": "4Dgg",
	"./prism-groovy.min": "vGNF",
	"./prism-groovy.min.js": "vGNF",
	"./prism-haml": "44IU",
	"./prism-haml.js": "44IU",
	"./prism-haml.min": "YKeH",
	"./prism-haml.min.js": "YKeH",
	"./prism-handlebars": "qkQG",
	"./prism-handlebars.js": "qkQG",
	"./prism-handlebars.min": "TZ0w",
	"./prism-handlebars.min.js": "TZ0w",
	"./prism-haskell": "WYC0",
	"./prism-haskell.js": "WYC0",
	"./prism-haskell.min": "yMuM",
	"./prism-haskell.min.js": "yMuM",
	"./prism-haxe": "QZgy",
	"./prism-haxe.js": "QZgy",
	"./prism-haxe.min": "IzvD",
	"./prism-haxe.min.js": "IzvD",
	"./prism-hpkp": "+Oso",
	"./prism-hpkp.js": "+Oso",
	"./prism-hpkp.min": "eexj",
	"./prism-hpkp.min.js": "eexj",
	"./prism-hsts": "qC+a",
	"./prism-hsts.js": "qC+a",
	"./prism-hsts.min": "DLHT",
	"./prism-hsts.min.js": "DLHT",
	"./prism-http": "Rm2u",
	"./prism-http.js": "Rm2u",
	"./prism-http.min": "uyuz",
	"./prism-http.min.js": "uyuz",
	"./prism-ichigojam": "amti",
	"./prism-ichigojam.js": "amti",
	"./prism-ichigojam.min": "4Gr2",
	"./prism-ichigojam.min.js": "4Gr2",
	"./prism-icon": "6s1u",
	"./prism-icon.js": "6s1u",
	"./prism-icon.min": "srwY",
	"./prism-icon.min.js": "srwY",
	"./prism-inform7": "bN8P",
	"./prism-inform7.js": "bN8P",
	"./prism-inform7.min": "P79f",
	"./prism-inform7.min.js": "P79f",
	"./prism-ini": "qWE9",
	"./prism-ini.js": "qWE9",
	"./prism-ini.min": "TI9a",
	"./prism-ini.min.js": "TI9a",
	"./prism-io": "gsdX",
	"./prism-io.js": "gsdX",
	"./prism-io.min": "bLuE",
	"./prism-io.min.js": "bLuE",
	"./prism-j": "mPOc",
	"./prism-j.js": "mPOc",
	"./prism-j.min": "U8/p",
	"./prism-j.min.js": "U8/p",
	"./prism-java": "8eeq",
	"./prism-java.js": "8eeq",
	"./prism-java.min": "yKjr",
	"./prism-java.min.js": "yKjr",
	"./prism-javascript": "GiG9",
	"./prism-javascript.js": "GiG9",
	"./prism-javascript.min": "CgLL",
	"./prism-javascript.min.js": "CgLL",
	"./prism-jolie": "2bEF",
	"./prism-jolie.js": "2bEF",
	"./prism-jolie.min": "uthy",
	"./prism-jolie.min.js": "uthy",
	"./prism-json": "m6/3",
	"./prism-json.js": "m6/3",
	"./prism-json.min": "U0qD",
	"./prism-json.min.js": "U0qD",
	"./prism-jsx": "DTmK",
	"./prism-jsx.js": "DTmK",
	"./prism-jsx.min": "yVgM",
	"./prism-jsx.min.js": "yVgM",
	"./prism-julia": "U/bx",
	"./prism-julia.js": "U/bx",
	"./prism-julia.min": "r3Gb",
	"./prism-julia.min.js": "r3Gb",
	"./prism-keyman": "Nmlq",
	"./prism-keyman.js": "Nmlq",
	"./prism-keyman.min": "hBWB",
	"./prism-keyman.min.js": "hBWB",
	"./prism-kotlin": "+shl",
	"./prism-kotlin.js": "+shl",
	"./prism-kotlin.min": "PO7e",
	"./prism-kotlin.min.js": "PO7e",
	"./prism-latex": "ZpIw",
	"./prism-latex.js": "ZpIw",
	"./prism-latex.min": "eOH1",
	"./prism-latex.min.js": "eOH1",
	"./prism-less": "YO+6",
	"./prism-less.js": "YO+6",
	"./prism-less.min": "4I+8",
	"./prism-less.min.js": "4I+8",
	"./prism-liquid": "DCtm",
	"./prism-liquid.js": "DCtm",
	"./prism-liquid.min": "8z+X",
	"./prism-liquid.min.js": "8z+X",
	"./prism-lisp": "cG+U",
	"./prism-lisp.js": "cG+U",
	"./prism-lisp.min": "3EvI",
	"./prism-lisp.min.js": "3EvI",
	"./prism-livescript": "Qacj",
	"./prism-livescript.js": "Qacj",
	"./prism-livescript.min": "DznA",
	"./prism-livescript.min.js": "DznA",
	"./prism-lolcode": "yx+A",
	"./prism-lolcode.js": "yx+A",
	"./prism-lolcode.min": "UtzM",
	"./prism-lolcode.min.js": "UtzM",
	"./prism-lua": "w96P",
	"./prism-lua.js": "w96P",
	"./prism-lua.min": "xe6O",
	"./prism-lua.min.js": "xe6O",
	"./prism-makefile": "DiGD",
	"./prism-makefile.js": "DiGD",
	"./prism-makefile.min": "FD4t",
	"./prism-makefile.min.js": "FD4t",
	"./prism-markdown": "26qR",
	"./prism-markdown.js": "26qR",
	"./prism-markdown.min": "wFip",
	"./prism-markdown.min.js": "wFip",
	"./prism-markup": "ISI6",
	"./prism-markup-templating": "TfX8",
	"./prism-markup-templating.js": "TfX8",
	"./prism-markup-templating.min": "5aAn",
	"./prism-markup-templating.min.js": "5aAn",
	"./prism-markup.js": "ISI6",
	"./prism-markup.min": "ZbXT",
	"./prism-markup.min.js": "ZbXT",
	"./prism-matlab": "ASrX",
	"./prism-matlab.js": "ASrX",
	"./prism-matlab.min": "DqGl",
	"./prism-matlab.min.js": "DqGl",
	"./prism-mel": "nyuY",
	"./prism-mel.js": "nyuY",
	"./prism-mel.min": "W9YR",
	"./prism-mel.min.js": "W9YR",
	"./prism-mizar": "+acJ",
	"./prism-mizar.js": "+acJ",
	"./prism-mizar.min": "zTlx",
	"./prism-mizar.min.js": "zTlx",
	"./prism-monkey": "ig/Z",
	"./prism-monkey.js": "ig/Z",
	"./prism-monkey.min": "xC9S",
	"./prism-monkey.min.js": "xC9S",
	"./prism-n4js": "3Eu2",
	"./prism-n4js.js": "3Eu2",
	"./prism-n4js.min": "wcyE",
	"./prism-n4js.min.js": "wcyE",
	"./prism-nasm": "5nNS",
	"./prism-nasm.js": "5nNS",
	"./prism-nasm.min": "ovRu",
	"./prism-nasm.min.js": "ovRu",
	"./prism-nginx": "wnU2",
	"./prism-nginx.js": "wnU2",
	"./prism-nginx.min": "aXWN",
	"./prism-nginx.min.js": "aXWN",
	"./prism-nim": "U5iO",
	"./prism-nim.js": "U5iO",
	"./prism-nim.min": "59UB",
	"./prism-nim.min.js": "59UB",
	"./prism-nix": "R7FU",
	"./prism-nix.js": "R7FU",
	"./prism-nix.min": "3+ti",
	"./prism-nix.min.js": "3+ti",
	"./prism-nsis": "OpTM",
	"./prism-nsis.js": "OpTM",
	"./prism-nsis.min": "r4OF",
	"./prism-nsis.min.js": "r4OF",
	"./prism-objectivec": "jWG0",
	"./prism-objectivec.js": "jWG0",
	"./prism-objectivec.min": "C6/H",
	"./prism-objectivec.min.js": "C6/H",
	"./prism-ocaml": "VJ2/",
	"./prism-ocaml.js": "VJ2/",
	"./prism-ocaml.min": "Q2c6",
	"./prism-ocaml.min.js": "Q2c6",
	"./prism-opencl": "e8ph",
	"./prism-opencl.js": "e8ph",
	"./prism-opencl.min": "dyK+",
	"./prism-opencl.min.js": "dyK+",
	"./prism-oz": "JlW4",
	"./prism-oz.js": "JlW4",
	"./prism-oz.min": "rfOj",
	"./prism-oz.min.js": "rfOj",
	"./prism-parigp": "THU+",
	"./prism-parigp.js": "THU+",
	"./prism-parigp.min": "kDTn",
	"./prism-parigp.min.js": "kDTn",
	"./prism-parser": "x3lw",
	"./prism-parser.js": "x3lw",
	"./prism-parser.min": "3DFE",
	"./prism-parser.min.js": "3DFE",
	"./prism-pascal": "ZV5t",
	"./prism-pascal.js": "ZV5t",
	"./prism-pascal.min": "69OQ",
	"./prism-pascal.min.js": "69OQ",
	"./prism-perl": "TSjD",
	"./prism-perl.js": "TSjD",
	"./prism-perl.min": "qPE1",
	"./prism-perl.min.js": "qPE1",
	"./prism-php": "ZVNe",
	"./prism-php-extras": "bbCC",
	"./prism-php-extras.js": "bbCC",
	"./prism-php-extras.min": "IxbB",
	"./prism-php-extras.min.js": "IxbB",
	"./prism-php.js": "ZVNe",
	"./prism-php.min": "TXq4",
	"./prism-php.min.js": "TXq4",
	"./prism-plsql": "Sxe9",
	"./prism-plsql.js": "Sxe9",
	"./prism-plsql.min": "BWYD",
	"./prism-plsql.min.js": "BWYD",
	"./prism-powershell": "xckP",
	"./prism-powershell.js": "xckP",
	"./prism-powershell.min": "T1Jo",
	"./prism-powershell.min.js": "T1Jo",
	"./prism-processing": "2hPP",
	"./prism-processing.js": "2hPP",
	"./prism-processing.min": "pKIQ",
	"./prism-processing.min.js": "pKIQ",
	"./prism-prolog": "LrcG",
	"./prism-prolog.js": "LrcG",
	"./prism-prolog.min": "jeAB",
	"./prism-prolog.min.js": "jeAB",
	"./prism-properties": "R+Dv",
	"./prism-properties.js": "R+Dv",
	"./prism-properties.min": "mp4+",
	"./prism-properties.min.js": "mp4+",
	"./prism-protobuf": "UAlk",
	"./prism-protobuf.js": "UAlk",
	"./prism-protobuf.min": "/PYN",
	"./prism-protobuf.min.js": "/PYN",
	"./prism-pug": "uHpy",
	"./prism-pug.js": "uHpy",
	"./prism-pug.min": "wjLP",
	"./prism-pug.min.js": "wjLP",
	"./prism-puppet": "Fan9",
	"./prism-puppet.js": "Fan9",
	"./prism-puppet.min": "sedi",
	"./prism-puppet.min.js": "sedi",
	"./prism-pure": "6HRK",
	"./prism-pure.js": "6HRK",
	"./prism-pure.min": "ZCgc",
	"./prism-pure.min.js": "ZCgc",
	"./prism-python": "IcAb",
	"./prism-python.js": "IcAb",
	"./prism-python.min": "jDgS",
	"./prism-python.min.js": "jDgS",
	"./prism-q": "/fXL",
	"./prism-q.js": "/fXL",
	"./prism-q.min": "uHyU",
	"./prism-q.min.js": "uHyU",
	"./prism-qore": "ly7L",
	"./prism-qore.js": "ly7L",
	"./prism-qore.min": "PmTJ",
	"./prism-qore.min.js": "PmTJ",
	"./prism-r": "R8Wo",
	"./prism-r.js": "R8Wo",
	"./prism-r.min": "7m0/",
	"./prism-r.min.js": "7m0/",
	"./prism-reason": "W981",
	"./prism-reason.js": "W981",
	"./prism-reason.min": "XUb3",
	"./prism-reason.min.js": "XUb3",
	"./prism-renpy": "Kvsf",
	"./prism-renpy.js": "Kvsf",
	"./prism-renpy.min": "IhEa",
	"./prism-renpy.min.js": "IhEa",
	"./prism-rest": "IShq",
	"./prism-rest.js": "IShq",
	"./prism-rest.min": "+AHn",
	"./prism-rest.min.js": "+AHn",
	"./prism-rip": "m5kT",
	"./prism-rip.js": "m5kT",
	"./prism-rip.min": "BjEQ",
	"./prism-rip.min.js": "BjEQ",
	"./prism-roboconf": "2Mmj",
	"./prism-roboconf.js": "2Mmj",
	"./prism-roboconf.min": "MLbH",
	"./prism-roboconf.min.js": "MLbH",
	"./prism-ruby": "hQRT",
	"./prism-ruby.js": "hQRT",
	"./prism-ruby.min": "aY8o",
	"./prism-ruby.min.js": "aY8o",
	"./prism-rust": "h2FW",
	"./prism-rust.js": "h2FW",
	"./prism-rust.min": "4OQ1",
	"./prism-rust.min.js": "4OQ1",
	"./prism-sas": "ZEId",
	"./prism-sas.js": "ZEId",
	"./prism-sas.min": "42sT",
	"./prism-sas.min.js": "42sT",
	"./prism-sass": "1vRr",
	"./prism-sass.js": "1vRr",
	"./prism-sass.min": "pvU7",
	"./prism-sass.min.js": "pvU7",
	"./prism-scala": "K3PL",
	"./prism-scala.js": "K3PL",
	"./prism-scala.min": "YT+y",
	"./prism-scala.min.js": "YT+y",
	"./prism-scheme": "GuMb",
	"./prism-scheme.js": "GuMb",
	"./prism-scheme.min": "Sd21",
	"./prism-scheme.min.js": "Sd21",
	"./prism-scss": "GThk",
	"./prism-scss.js": "GThk",
	"./prism-scss.min": "HYRm",
	"./prism-scss.min.js": "HYRm",
	"./prism-smalltalk": "Rsr/",
	"./prism-smalltalk.js": "Rsr/",
	"./prism-smalltalk.min": "F/Ma",
	"./prism-smalltalk.min.js": "F/Ma",
	"./prism-smarty": "Aa1t",
	"./prism-smarty.js": "Aa1t",
	"./prism-smarty.min": "q8kq",
	"./prism-smarty.min.js": "q8kq",
	"./prism-soy": "fMl2",
	"./prism-soy.js": "fMl2",
	"./prism-soy.min": "SbIL",
	"./prism-soy.min.js": "SbIL",
	"./prism-sql": "iynh",
	"./prism-sql.js": "iynh",
	"./prism-sql.min": "QzPz",
	"./prism-sql.min.js": "QzPz",
	"./prism-stylus": "nEV5",
	"./prism-stylus.js": "nEV5",
	"./prism-stylus.min": "ayc0",
	"./prism-stylus.min.js": "ayc0",
	"./prism-swift": "ga2V",
	"./prism-swift.js": "ga2V",
	"./prism-swift.min": "yhV1",
	"./prism-swift.min.js": "yhV1",
	"./prism-tcl": "lw+I",
	"./prism-tcl.js": "lw+I",
	"./prism-tcl.min": "bohG",
	"./prism-tcl.min.js": "bohG",
	"./prism-textile": "bnW4",
	"./prism-textile.js": "bnW4",
	"./prism-textile.min": "L/ms",
	"./prism-textile.min.js": "L/ms",
	"./prism-tsx": "paiR",
	"./prism-tsx.js": "paiR",
	"./prism-tsx.min": "8JjK",
	"./prism-tsx.min.js": "8JjK",
	"./prism-twig": "6pl5",
	"./prism-twig.js": "6pl5",
	"./prism-twig.min": "fYhm",
	"./prism-twig.min.js": "fYhm",
	"./prism-typescript": "fXP7",
	"./prism-typescript.js": "fXP7",
	"./prism-typescript.min": "GsTH",
	"./prism-typescript.min.js": "GsTH",
	"./prism-vbnet": "votr",
	"./prism-vbnet.js": "votr",
	"./prism-vbnet.min": "f60v",
	"./prism-vbnet.min.js": "f60v",
	"./prism-velocity": "BNKi",
	"./prism-velocity.js": "BNKi",
	"./prism-velocity.min": "V1F3",
	"./prism-velocity.min.js": "V1F3",
	"./prism-verilog": "+C5G",
	"./prism-verilog.js": "+C5G",
	"./prism-verilog.min": "BN58",
	"./prism-verilog.min.js": "BN58",
	"./prism-vhdl": "GcLb",
	"./prism-vhdl.js": "GcLb",
	"./prism-vhdl.min": "s1kQ",
	"./prism-vhdl.min.js": "s1kQ",
	"./prism-vim": "mt0C",
	"./prism-vim.js": "mt0C",
	"./prism-vim.min": "1/E6",
	"./prism-vim.min.js": "1/E6",
	"./prism-visual-basic": "O/cZ",
	"./prism-visual-basic.js": "O/cZ",
	"./prism-visual-basic.min": "1qyG",
	"./prism-visual-basic.min.js": "1qyG",
	"./prism-wasm": "Ks8+",
	"./prism-wasm.js": "Ks8+",
	"./prism-wasm.min": "OTVr",
	"./prism-wasm.min.js": "OTVr",
	"./prism-wiki": "isKi",
	"./prism-wiki.js": "isKi",
	"./prism-wiki.min": "8oPV",
	"./prism-wiki.min.js": "8oPV",
	"./prism-xeora": "aZ0M",
	"./prism-xeora.js": "aZ0M",
	"./prism-xeora.min": "wSen",
	"./prism-xeora.min.js": "wSen",
	"./prism-xojo": "NZwE",
	"./prism-xojo.js": "NZwE",
	"./prism-xojo.min": "NLAo",
	"./prism-xojo.min.js": "NLAo",
	"./prism-yaml": "GEa9",
	"./prism-yaml.js": "GEa9",
	"./prism-yaml.min": "aLiU",
	"./prism-yaml.min.js": "aLiU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hYMB";


//////////////////
// WEBPACK FOOTER
// ./node_modules/prismjs/components ^\.\/prism\-.*$
// module id = hYMB
// module chunks = 1